import React from 'react'
import utils from 'utils'
import { useForm } from 'form'
import { Button, ErrorMessage } from 'components'
import fb from 'lib/form/formBuilder'

export function StoreSelector({ form, data, fieldName }) {
  const [editingStore, setEditingStore] = React.useState()

  const field = form.findControl(fieldName)
  const storesInFrom = field.value || []
  const stores = (data.stores || []).filter((x) => x.storeName)

  // form data for the right hand store editor
  const editingStoreForm = useForm({}, {})

  function onStoreSelectChanged(e) {
    let currentStores = field.value || []
    if (e.target.checked) {
      //add
      currentStores.push({
        storeCode: e.target.value,
        buyOnlineOverride: null,
        storeUrlOverride: null,
        notes: null,
      })
    } else {
      //remove
      currentStores = currentStores.filter(
        (x) => x.storeCode !== e.target.value
      )
    }
    field.value = currentStores
    form.reset()
  }

  function onEdit(storeCode) {
    let currentStores = field.value || []
    const store = utils.array.find(
      currentStores,
      (x) => x.storeCode === storeCode
    )
    resetEditingStoreModel(store)
    setEditingStore(store)
  }

  function onEditSaved(storeCode, store) {
    let currentStores = field.value || []
    currentStores = currentStores.filter((x) => x.storeCode !== storeCode)
    currentStores.push(store)
    field.value = currentStores
    form.reset()
    setEditingStore(null) // close editor
  }

  function onCancel() {
    setEditingStore(null) // close editor
  }

  function resetEditingStoreModel(store) {
    const storeInData = utils.array.find(
      data.stores,
      (x) => x.storeCode === store.storeCode
    )
    const buyOnlineOptions = [
      {
        name:
          'Use default store setting (' +
          (storeInData.buyOnline ? 'Buy Online' : 'No Online') +
          ')',
        value: '',
      },
      { name: 'Buy Online', value: true },
      { name: 'No Online', value: false },
    ]
    const model = fb.group({
      buyOnlineOverride: [
        store.buyOnlineOverride === false
          ? false
          : store.buyOnlineOverride || '',
        [],
        {
          type: 'select',
          label: 'Overriding Buy Online',
          options: buyOnlineOptions,
        },
      ],
      storeUrlOverride: [
        store.storeUrlOverride || '',
        [],
        { type: 'text', label: 'Overriding Link' },
      ],
      notes: [store.notes || '', [], { type: 'text', label: 'Notes' }],
      storeInData: [storeInData],
    })
    editingStoreForm.reset(model)
  }

  return (
    <div className="row">
      <div className="col-md-7">
        <div className="storeSelector">
          {stores.map((store, index) => (
            <Store
              key={index}
              storesInFrom={storesInFrom}
              storeInData={store}
              onStoreSelectChanged={onStoreSelectChanged}
              onEdit={onEdit}
            />
          ))}
        </div>
      </div>
      <div className="col-md-5">
        {editingStore && (
          <StoreEdit
            form={editingStoreForm}
            store={editingStore}
            stores={stores}
            onChange={onEditSaved}
            onCancel={onCancel}
          />
        )}
      </div>
    </div>
  )
}

function Store({ storesInFrom, storeInData, onStoreSelectChanged, onEdit }) {
  const forProduct = utils.array.find(
    storesInFrom,
    (x) => x.storeCode === storeInData.storeCode
  )
  const overrides = []
  if (forProduct) {
    // console.log(typeof forProduct.buyOnlineOverride)
    // console.log(forProduct.buyOnlineOverride, forProduct.buyOnlineOverride === true, forProduct.buyOnlineOverride === false)

    // if (forProduct.buyOnlineOverride === 'true'){
    //   overrides.push(`Buy Online`)
    // } else if (forProduct.buyOnlineOverride === 'false'){
    //   overrides.push(`No Online`)
    // }
    // if (forProduct.storeUrlOverride) {
    //   overrides.push(`Store Url: ${forProduct.storeUrlOverride}`);
    // }
    if (
      forProduct.buyOnlineOverride === 'true' ||
      forProduct.buyOnlineOverride === true
    ) {
      overrides.push(`Buy Online`)
    } else if (
      forProduct.buyOnlineOverride === 'false' ||
      forProduct.buyOnlineOverride === false
    ) {
      overrides.push(`No Online`)
    }
    if (forProduct.storeUrlOverride) {
      overrides.push(`Store Url: ${forProduct.storeUrlOverride}`)
    }
  }

  return (
    <div className="storeSelector__item">
      <label>
        <input
          type="checkbox"
          value={storeInData.storeCode}
          checked={!!forProduct}
          onChange={onStoreSelectChanged}
        />
        <span className="storeSelector__country">[{storeInData.country}]</span>
        <span className="storeSelector__name">{storeInData.storeName}</span>
      </label>
      {forProduct && forProduct.notes && (
        <span className="storeSelector__notes">({forProduct.notes})</span>
      )}
      {!!forProduct && (
        <button
          className="btn btn-secondary btn-sm storeSelector__edit"
          type="button"
          onClick={() => {
            onEdit(storeInData.storeCode)
          }}
        >
          Edit
        </button>
      )}

      {overrides.length > 0 && (
        <div className="storeSelector__overrides">{overrides.join('\n')}</div>
      )}
    </div>
  )
}

function StoreEdit({ form, store, stores, onChange, onCancel }) {
  const storeInData = utils.array.find(
    stores,
    (x) => x.storeCode === store.storeCode
  )
  console.log(store, storeInData)

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue(), storeCode: store.storeCode }
      onChange(store.storeCode, value)
    })
  }

  const render = (name) => form.renderControl(name)
  return (
    <div className="">
      <h3>
        Editing '[{storeInData.country}] {storeInData.storeName}'
      </h3>
      <p style={{ color: 'chocolate' }}>
        The following settings are for this product only.
      </p>
      <div>{render('buyOnlineOverride')}</div>
      <div>{render('storeUrlOverride')}</div>
      <div>{render('notes')}</div>

      <div className="row">
        <div className="col-12 actions">
          <Button btnStyle="secondary" onClick={save} status={form.status}>
            Update
          </Button>
          <Button btnStyle="outline-dark" onClick={onCancel}>
            Cancel
          </Button>
          <ErrorMessage errors={form.errors} />
        </div>
      </div>
    </div>
  )
}
